import { useContext, useEffect } from "react";
import MapContext from "./MapContext";
import Overlay from 'ol/Overlay';

import { Button, ButtonGroup, IconButton } from "@mui/material";

import { fromLonLat } from "ol/proj";

import Config from '../../config.json';
import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';

import { Group as LayerGroup } from "ol/layer";
import { transform } from 'ol/proj';

const PopUp = ({ coordinate, show, content, setShow, level, setLevel, kode, layer, setIdProvince, setIdMunicipal, setIdKecamatan, setIdDesa }) => {
    const { map } = useContext(MapContext);

    useEffect(() => {

        if (coordinate) {
            //console.log(coordinate)
            //console.log(transform(coordinate, 'EPSG:3857','EPSG:4326'))
            //console.log(show)
            map.getOverlayById('popup').setPosition(coordinate);
            //if (popup)
            //    popup.setPosition(transform(coordinate, 'EPSG:3857','EPSG:4326'));
        }
    }, [map, coordinate]);

    useEffect(() => {
        if (!map) return;
        var popup = new Overlay({
            id: 'popup',
            element: document.getElementById('popup'),
            autoPan: true,
            autoPanAnimation: {
                duration: 250,
            },
        });
        //if(coordinate)
        //    popup.setPosition(fromLonLat(coordinate));
        map.addOverlay(popup);

        /*
         map.on('singleclick', function (evt) {
             //
             setShow(true);
             popup.setPosition(evt.coordinate);
             
         })
         */


        /*
        var container = document.createElement('div');
        container.className = 'ol-popup';
        //container.innerHTML="Halo"
        var closer = document.createElement('span');
        //closer.setAttribute("href", "");
        closer.className = 'ol-popup-closer';
        //<a href="#" id="popup-closer" className="ol-popup-closer"></a>
        //<div id="popup-content" ></div>
        container.append(closer)
        var content = document.createElement('div');
        var info = document.getElementById('info').innerHTML;
        var k = create_content(feature, info);
        content.innerHTML = k +"<br />";
        var b = document.createElement('button');
        b.innerHTML = "zoom";
        content.append(b);
        //k = k + "<br /> <button>zoom to</button>";
        //content.innerHTML = k;
        container.append(content)
        overlay = new Overlay({
            element: container,
            autoPan: true,
            autoPanAnimation: {
                duration: 250,
            },
        });

        closer.addEventListener('click', function () {
            featureSelected.getSource().clear();
            overlay.setPosition(undefined);
            closer.blur();
            selected = null;
            return false;
        });
        map.addOverlay(overlay);
        overlay.setPosition(evt.coordinate);
        */

    }, [map]);

    function handleClose() {
        setShow(false)
        let layers = map.getLayers().getArray();
        var idx = 0;
        layers.forEach(function (l, i) {
            if (l.get("id") === 'selected_layer') {
                idx = i;
            }
        })
        var sourceSelected = layers[idx].getSource();
        //console.log(sourceSelected)
        sourceSelected.clear()
    }

    function handleZoom() {
        setShow(false)
        let layers = map.getLayers().getArray();
        var idx = 0;
        layers.forEach(function (l, i) {
            if (l.get("id") === 'selected_layer') {
                idx = i;
            }
        })
        var sourceSelected = layers[idx].getSource();
        //console.log(sourceSelected)
        map.getView().fit(sourceSelected.getExtent())
        sourceSelected.clear()
        if (level === "negara") {
            setLevel("provinsi")
            setIdProvince(kode)
        } else if (level === "provinsi") {
            setLevel("kabkot")
            setIdMunicipal(kode)
        } else if (level === "kabkot") {
            setLevel("kecamatan")
            setIdKecamatan(kode)
        } else if (level === "kecamatan") {
            setLevel("desa")
            setIdDesa(kode)
        }

        //handleClose();

    }

    function handleZoomOut() {
        setShow(false)

        if (level === "desa") {
            setLevel("kecamatan")
            setIdKecamatan(kode)
        } else if (level === "kecamatan") {
            setLevel("kabkot")
            setIdMunicipal(kode)
        } else if (level === "kabkot") {
            setLevel("provinsi")
            setIdProvince(kode)
        } else if (level === "provinsi") {
            setLevel("negara")
            setIdProvince(0)
        }

        //handleClose();

    }
    var listArea = [
        /*53,
        '53.01','53.02','53.03','53.04','53.05','53.06','53.07','53.08','53.09','53.10','53.11','53.12','53.13','53.14','53.15','53.16','53.17','53.18','53.19','53.20','53.21','53.71',
        '53.02.01', '53.02.02', '53.02.03', '53.02.04', '53.02.05', '53.02.06', '53.02.07', '53.02.08', '53.02.09', '53.02.10', '53.02.11', '53.02.12', '53.02.13', '53.02.14', '53.02.15', 
        '53.02.16', '53.02.17', '53.02.18', '53.02.19', '53.02.20', '53.02.21', '53.02.22', '53.02.23', '53.02.24', '53.02.25', '53.02.26', '53.02.27', '53.02.28', '53.02.29', '53.02.30', 
        '53.02.31', '53.02.32',
        */
        '53.02.02.2001', '53.02.02.2003', '53.02.02.2006', '53.02.02.2008', '53.02.02.2010', '53.02.02.2012', '53.02.02.2013'];

    function generate_button() {
        if (level === "kabkot" || level === "kecamatan" || level === "desa") {
            return ""
        }else{
           return <Button variant="contained" size="small" fullWidth color="secondary" disableElevation={true} style={{ marginTop: "15px", borderRadius: "20px" }} onClick={() => handleZoom()}>Zoom In</Button>
        }
        /*
        if (level === "negara") {
            if (kode == 12)
                return <Button variant="contained" size="small" fullWidth color="secondary" disableElevation={true} style={{ marginTop: "15px", borderRadius: "20px" }} onClick={() => handleZoom()}>Zoom In</Button>
            else
                return ""
        } else if (level === "kecamatan") {
            if (String(kode).includes('12.71'))
                return <Button variant="contained" size="small" fullWidth color="secondary" disableElevation={true} style={{ marginTop: "15px", borderRadius: "20px" }} onClick={() => handleZoom()}>Zoom In</Button>
            else
                return ""

        } else if (level === "desa") {
                return ""
        } else {
            return <Button variant="contained" size="small" fullWidth color="secondary" disableElevation={true} style={{ marginTop: "15px", borderRadius: "20px" }} onClick={() => handleZoom()}>Zoom In</Button>
        }*/
    }
    return (
        <div id="popup" className="ol-popup" style={{ display: show ? 'block' : 'none' }}>
            <span className="ol-popup-closer" onClick={() => handleClose()}></span>
            <div style={{ maxHeight: "250px", overflowY: 'auto' }}>
               {content}
            </div>
            {
                generate_button()
            }
            {
                //level === "desa"? "": listArea.includes(kode)? <Button variant="contained" size="small" fullWidth color="secondary" disableElevation={true} style={{ marginTop: "15px", borderRadius: "20px" }} onClick={()=>handleZoom()}>Zoom In</Button>:""}


                //<Button variant="contained" size="small" fullWidth color="secondary" disableElevation={true} style={{ marginTop: "15px", borderRadius: "20px" }} onClick={()=>handleZoomOut()}>Zoom Out</Button>
            }
        </div>
    )
};



export default PopUp;